module.exports = __webpack_public_path__ + "static/media/scorito.8b4c63c0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/scorito.webp
// module id = 416
// module chunks = 0